import { UseLoadingReturn } from "@/hooks/use-loading";
import useRemove from "@/hooks/use-remove";
import t2payService from "@/services/t2pay.service";
import { RemoveByIdProps } from "@/types/requests.types";

export type Return = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemovePaymentType = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (id) => t2payService.deletePaymentType(id),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, remove };
};

export default useRemovePaymentType;
